var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile submission-details" },
    [
      _c("div", { staticClass: "message_date" }, [
        _vm._v(_vm._s(_vm.detailsValue.dsCreateTime)),
      ]),
      _c("DsfMessagePanel", { attrs: { arrowDirection: "right" } }, [
        _c(
          "div",
          {
            staticClass: "message_title",
            attrs: { slot: "content" },
            slot: "content",
          },
          [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.detailsValue.typeText || "")),
            ]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.detailsValue.suggest || "")),
            ]),
            _c(
              "div",
              { staticClass: "message_img" },
              _vm._l(_vm.imgUrl(), function (item, index) {
                return _c("van-image", {
                  key: index,
                  attrs: {
                    radius: "5",
                    width: "80",
                    height: "80",
                    fit: "cover",
                    src: item.relativePath,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.messageChange(index)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "error",
                        fn: function () {
                          return [
                            _c("img", {
                              staticClass: "err_img",
                              attrs: {
                                src: require("../../assets/styles/themes/img/submissionErr_mobile.png"),
                                alt: "",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              1
            ),
          ]
        ),
      ]),
      _vm.detailsValue.replyStatusValue == "1"
        ? _vm._l(_vm.detailsValue.suggestReplyList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", { staticClass: "message_date" }, [
                  _vm._v(_vm._s(item.dsCreateTime || "")),
                ]),
                _vm.detailsValue.replyStatusValue == "1"
                  ? _c(
                      "DsfMessagePanel",
                      { attrs: { arrowDirection: "left" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "message_title",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("div", { staticClass: "reply" }, [
                              _c("span", [_vm._v("回复内容：")]),
                              _vm._v(
                                " " +
                                  _vm._s(item.detail) +
                                  "（" +
                                  _vm._s(item.dsCreateUserName) +
                                  "） "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _c("van-image-preview", {
        attrs: {
          images: _vm.preview,
          "class-name": "preview_box",
          "start-position": _vm.startPosition,
        },
        model: {
          value: _vm.showImage,
          callback: function ($$v) {
            _vm.showImage = $$v
          },
          expression: "showImage",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }